import angular from 'angular';

angular.module('commonServices').filter('translateList', ['$translate', translateList]);

function translateList($translate) {
  var translateListFilter = function(input, name, def, params, forceLanguage) {
    if (name == null) return def || null;
    var key =
      name.toLowerCase() + '_' + (!input && input !== 0 ? 'null' : ('' + input).toLowerCase());
    var translation = $translate.instant(key, params, null, forceLanguage, 'escaped');

    if (key === translation) return def || null;
    return translation;
  };
  if ($translate.statefulFilter()) {
    translateListFilter.$stateful = true;
  }
  return translateListFilter;
}
